<template>
  <transition name="fade">
    <div class="phrase-overlay" v-if="unpermitted_drawer">
      <div class="create-phrase-wrap">
        <div class="list-create">
          <div class="newmessage-title">
            <span v-if="type == 'page'">アカウントの管理者に連絡</span>
            <span v-else-if="type == 'noregister'">メールアドレス・パスワードを設定してください</span>
            <span v-else>この操作を行う権限がありません</span>
            <div class="flex-space"></div>
            <div class="newmessage-button" @click="closeModal()">
              <font-awesome-icon :icon="['fal', 'times']" />
            </div>
          </div>

          <div class="member-link-wrap">
            <div style="margin-bottom:20px; line-height:20px; font-weight:400">
              <span v-if="type == 'page'">このページを表示するには、以下のいずれかのアカウントの管理者に連絡して権限の付与を依頼してください。</span>
              <span v-else-if="type == 'noregister'">メールアドレス・パスワードを設定するには、以下のいずれかのアカウントの管理者から招待リンクを受け取り、リンク先のページから設定を行ってください。</span>
              <span v-else>この操作を行うには、以下のいずれかのアカウントの管理者に連絡して権限の付与を依頼してください。</span>
              
            </div>
            <div class="up-admin-member-wrap">
              <div v-for="admin_member in admin_member" :key="admin_member.person_id">
                <a :href="'mailto:' + admin_member.email" class="unp-admin-member pointer">
                  <el-image :src="admin_member.img_url" class="setting-member-profile small setting">
                    <div slot="error" class="setting-member-noimg small setting pointer">{{ admin_member.person_name | firstLetter }}</div>
                  </el-image>
                  <div style="display: flex; flex-flow:column; margin-left:10px">
                    <div style="color:#333;">{{ admin_member.person_name }}</div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div class="list-create-footer">
            <el-button @click="closeModal()">閉じる</el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadAdminMemberAPI = root + "/api/member/load_admin_member";

export default {
  name: "unpermittedDrawer",
  props: ["unpermitted_drawer", "type"],
  components: {},
  data() {
    return {
      admin_member: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
  },
  mounted() {
    this.loadAdminMember();
  },
  methods: {
    loadAdminMember() {
      this.axios
        .get(loadAdminMemberAPI, {
          params: {
            token: this.token,
          },
        })
        .then((response) => {
          this.admin_member = response.data.admin_member;
        })
        .catch(() => {});
    },
    closeModal() {
      if (this.type == "page" || this.type=='noregister') {
        this.$emit("update:unpermitted_drawer", false);
      } else {
        this.$store.dispatch("openUnpermittedDrawer", false)
      }
    },
  },
  filters: {
    firstLetter(val) {
      return val.slice(0, 1);
    },
  },
  watch: {},
};
</script>
